'use strict';
module.exports = function TextWidthCache(abstractWidthFunction) {
	if (!abstractWidthFunction || typeof abstractWidthFunction !== 'function') {
		throw new Error('invalid-args');
	}
	const self = this,
		sizeCache = {};
	self.textWidth = function (text, fontMetrics) {
		if (!fontMetrics || !fontMetrics.weight || !fontMetrics.family || !fontMetrics.fontSize) {
			throw new Error(`invalid-args;fontMetrics:${fontMetrics}`);
		}
		if (!sizeCache[fontMetrics.family]) {
			sizeCache[fontMetrics.family] = {};
		}
		if (!sizeCache[fontMetrics.family][fontMetrics.weight]) {
			sizeCache[fontMetrics.family][fontMetrics.weight] = {};
		}
		if (!sizeCache[fontMetrics.family][fontMetrics.weight].hasOwnProperty(text)) {
			sizeCache[fontMetrics.family][fontMetrics.weight][text] = abstractWidthFunction(text, fontMetrics);
		}
		return sizeCache[fontMetrics.family][fontMetrics.weight][text];
	};
};

